export enum ANALYTICS_SERVICE {
  GET_SPENDING_TREND = `/ms/spm-reporting/v1/spendtrend`,
  GET_SPENDING_CATEGORIES = `/ms/spm-reporting/v1/categoryspend`,
  GET_SPENDING_TEAM = `/ms/spm-reporting/v1/teamspend`,
  GET_SPENDING_MERCHANT = `/ms/spm-reporting/v1/merchantspend`,
}
